import type { RoutableQueryBuilderData } from 'shared/modules/query-builder/routable-query-builder/routable-query-builder.component';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { RuleSet } from 'angular2-query-builder/dist/components';
import { oneStatusChain } from 'app/store/project/status-chains/status-chains.selectors';
import { selectFirst } from 'core/utils/rx-common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class RoutableQueryBuilderResolver {
  constructor(private store$: Store) {}

  resolve(route: ActivatedRouteSnapshot): Observable<RoutableQueryBuilderData> {
    const chainId = route.params.statusChainId;
    const chainedId = route.params.chainedId;

    return this.store$.pipe(
      selectFirst(oneStatusChain, { id: chainId }),
      map((chain) => {
        const chainedCourier = chain?.chainedStatuses.find(c => c.chainedId === chainedId);
        const ruleSet = chainedCourier?.ruleSet || { condition: 'and', rules: [] } as RuleSet;

        return { chainedId, ruleSet };
      }),
    );
  }
}
